<script setup lang="ts">
import { gaiaFonts, gaiaFontSize, gaiaFontWeight, gaiaNeutral } from '../themes/tokens';

defineProps({
  /** The revision's version number — rendered as "v3". */
  version: {
    type: Number,
    required: true,
  },
});

const border = gaiaNeutral.border;
const color = gaiaNeutral.textTertiary;
const font = gaiaFonts.mono;
const size = gaiaFontSize.nano;
const weight = String(gaiaFontWeight.regular);
</script>

<template>
  <!-- The file's version chip beside its name (Contract Vault list, History). -->
  <span class="gaia-version-badge">v{{ version }}</span>
</template>

<style scoped>
.gaia-version-badge {
  display: inline-flex;
  align-items: center;
  flex: none;
  height: 19px;
  padding: 0 7px;
  border: 1px solid v-bind(border);
  border-radius: 7px;
  font-family: v-bind(font);
  font-size: v-bind(size);
  font-weight: v-bind(weight);
  color: v-bind(color);
}
</style>
